<template>
  <div class="view-vendor">
    <transition name="modal">
      <div class="modal-mask modal-mask-height">
        <div class="modal-wrapper">
          <div class="modal-dialog modal-dialog-scrollable modal-width">
            <div class="modal-content">
              <div class="modal-header">
                <div class="preview-msg-header">
                  <h4 style="font-size: 22px;">Refund Details</h4>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-6 border-grey-right"
                    ><h4 class="modal-title mr-t10"> Service Name </h4>
                    <p class=" text-css break-big-word">Window Washing</p></div
                  >
                  <div class="col-6 "
                    ><h4 class="modal-title mr-t10">Total Cost </h4>
                    <p class=" text-css break-big-word">$ 1000</p></div
                  >

                  <div class="col-6 border-grey-right"
                    ><h4 class="modal-title mr-t10">Resident Name </h4>
                    <p class=" text-css break-big-word">Bulmer</p></div
                  >
                  <div class="col-6 "
                    ><h4 class="modal-title mr-t10">Amount Paid </h4>
                    <p class=" text-css break-big-word">$ 1000</p></div
                  >
                  <div class="col-6 border-grey-right"
                    ><h4 class="modal-title mr-t10"> Requested Date </h4>
                    <p class=" text-css break-big-word">03-10-2022 </p></div
                  >

                  <div class="col-6 "
                    ><h4 class="modal-title mr-t10">Outstanding Amount </h4>
                    <p class="text-css break-big-word">$ 0</p></div
                  >

                  <div class="col-6 border-grey-right"
                    ><h4 class="modal-title mr-t10">Status </h4>
                    <p class=" text-css break-big-word">
                      Refund Requested</p
                    ></div
                  >
                </div>
                <div class="row mr-t10">
                  <div class="col-12">
                    <div class="form-group ">
                      <label class="font-fam" for="exampleFormControlTextarea1"
                        >Refund Reason from Resident</label
                      >
                      <textarea
                        id="message"
                        v-model="feedbackMessage"
                        class="form-control"
                        name="message"
                        placeholder="Please enter your feedback here..."
                        rows="2"
                        readonly
                      >
                      </textarea>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group ">
                      <label class="font-fam" for="exampleFormControlTextarea1"
                        >Admin Comment</label
                      >
                      <textarea
                        id="message"
                        class="form-control"
                        name="message"
                        placeholder="Please enter your feedback here..."
                        rows="2"
                      >
                      </textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <div class="displayflex ">
                  <div class="wd-20 mr-2">
                    <button
                      type="button"
                      class="btn btn f-w-red-btn save-btn-width"
                      @click="sendResponse(true)"
                    >
                      Approve
                    </button>
                  </div>
                  <div class="wd-20"> </div>&nbsp;&nbsp;
                  <div class="wd-20 mr-2 ">
                    <button
                      type="button"
                      class="btn trans-btn full-width"
                      @click="sendResponse(false)"
                    >
                      Reject
                    </button>
                  </div>
                  <div class="wd-20 mr-2 ">
                    <button
                      type="button"
                      class="btn trans-btn full-width"
                      @click="sendResponse(false)"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      feedbackMessage:
        'The cleaning method is ineffective. It also shattered one of the window panes.',
    }
  },
  methods: {
    sendResponse(val) {
      this.$emit('response', val)
    },
  },
}
</script>
<style scoped>
.view-vendor .border-grey-right {
  border-right: 1px solid grey;
}
.view-vendor .text-css {
  text-align: justify;
  text-decoration: none;
  font-size: 16px !important;
  font-family: JosefinSans-SemiBold !important;
}
.view-vendor .modal-mask {
  position: fixed;
  z-index: 9000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.view-vendor .modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.view-vendor .modal-header {
  border-bottom: none;
}
.view-vendor .preview-msg-header {
  /* justify-content: center; */
  padding: 0;
  display: inline;
  width: 100%;
  /* padding-left: 15px; */
  border-bottom: none;
}
.view-vendor .modal-width {
  padding: 20px;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  border: 0px;
}
.view-vendor .modal-dialog {
  width: 100%;
  height: 100%;
  padding: 0;
}

.view-vendor .modal-content {
  height: 100%;
  /* border-radius: 0; */
}
.font-fam {
  font-family: JosefinSans-Bold;
}
.font-size {
  font-family: 'JosefinSans-SemiBold' !important;
  font-size: 14px;
}
</style>
